import axios from "axios";
import { Mutex } from "async-mutex";
import { sessionLogout } from "./services/apiService";

const baseApiUrl = process.env.REACT_APP_BASE_API;
const mutex = new Mutex();

// Set default timeout to 5 minutes
axios.defaults.timeout = 300000;

const getAuthToken = () => {
  const tokenString = sessionStorage.getItem("token");
  const token =
    tokenString !== "" && tokenString !== null ? JSON.parse(tokenString) : "";
  const accessToken = token !== "" ? token.accessToken : "";
  return accessToken;
};

const onRetry = async (req) => {
  const { config } = req;

  const { accessToken } = JSON.parse(sessionStorage.getItem("token"));
  const options = {
    method: config.method,
    url: config.url,
    headers: config.headers,
    data: config.data,
  };
  options.headers["Authorization"] = accessToken;
  const resp = await axios(options);
  return resp;
};

axios.interceptors.request.use((config) => {
  const authToken = getAuthToken();
  if (authToken) {
    config.headers.Authorization = `${authToken}`;
  }
  return config;
});

axios.interceptors.response.use(
  async (response) => {
    if (response.data.data) {
      if (response.config.url.includes("login")) {
        const accessToken = response.data.data["accessToken"];
        const refreshToken = response.data.data["refreshToken"];
        if (accessToken || refreshToken) {
          const token = {
            accessToken: accessToken,
            refreshToken: refreshToken,
          };
          sessionStorage.setItem("token", JSON.stringify(token));
        }
      }
    }
    return response;
  },
  async (error) => {
    try {
      const { status, statusText, data, config } = error.response;
      if (
        status === 401 &&
        status == 403 &&
        config.url.includes("user/login")
      ) {
        return Promise.reject(error);
      }
      if (config.url.includes("user/login")) {
        return Promise.reject(error);
      }
      if (
        status === 401 ||
        (status === 403 && config.url.includes !== "user/login")
      ) {
        if (
          (status === 401 && status == 403) ||
          config.url.includes("refresh-token")
        ) {
          return sessionLogout();
        } else {
          const release = await mutex.acquire();
          let { accessToken, refreshToken } = JSON.parse(
            sessionStorage.getItem("token")
          );
          let retry = false;
          try {
            if (
              accessToken != null &&
              accessToken !== error.config.headers.Authorization
            ) {
              retry = true;
            } else {
              if (refreshToken) {
                const data = { refresh_token: refreshToken };
                const option = {
                  method: "post",
                  url: baseApiUrl + "/v1/refresh-token",
                  data,
                };
                const resp = await axios(option);
                if (
                  resp &&
                  resp.data.status === 200 &&
                  resp.data.data &&
                  resp.data.data.access_token !== ""
                ) {
                  const token = {
                    accessToken: resp.data.data.access_token,
                    refreshToken: resp.data.data.refresh_token,
                  };
                  sessionStorage.setItem("token", JSON.stringify(token));
                  retry = true;
                }
                if (resp && (resp.code === 401 || resp.code === 403)) {
                  return sessionLogout();
                }
                // retry = resp && resp.status === 200;
              } else {
              }
            }
          } finally {
            release();
          }
          if (retry) {
            const resp = await onRetry(error.response);
            return Promise.resolve(resp);
          }
        }
      }
      return Promise.reject(error);
    } catch (err) {
      return Promise.reject(err);
    }
  }
);
